// use this to update the document title (page title in browser tab) - make sure to use for every route or the document title will stay at whatever it has been set to previously
import { useEffect } from 'react'

export const useDocumentTitle = title => {
  useEffect(() => {
    document.title = title
  }, [title])
}
